import { API_URL } from '@/utils/constants'

const FALLBACK_BUCKET_MS = 60_000

const fetchIndexedBlockHeight = async () => {
	try {
		const res = await fetch(`${API_URL}/blockheight`)
		if (!res.ok) throw new Error(`blockheight ${res.status}`)
		const height = (await res.text()).trim()
		// Only trust a purely-numeric body. A stray HTML/error page would
		// otherwise be passed through verbatim as the `index_height` cache-bust
		// param; fall back to the wall-clock bucket instead.
		if (/^\d+$/.test(height)) return height
		return `${Math.floor(Date.now() / FALLBACK_BUCKET_MS)}`
	} catch (_e) {
		return `${Math.floor(Date.now() / FALLBACK_BUCKET_MS)}`
	}
}

export const blockScopedNoStoreFetcher = async (url: string) => {
	const height = await fetchIndexedBlockHeight()
	const separator = url.includes('?') ? '&' : '?'
	const res = await fetch(`${url}${separator}index_height=${encodeURIComponent(height)}`, {
		cache: 'no-store',
		headers: { 'Cache-Control': 'no-cache' }
	})
	if (!res.ok) throw new Error(`block scoped fetch ${res.status}`)
	return res.json()
}
